import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_ORDER_URL

export const getExternal = async (queryParam) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
  }

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/branch/external',
    params: params,
  })

  return response?.data
}